import { Div, Base, Img } from '@codesuma/baseline'
import style from './index.module.css'

// The add-item bar: a text input plus a "+" button that lights up once there's
// something to add. Emits 'add' with the trimmed value, then clears itself.
export const AddBar = () => {
    const base = Div()
    base.addClass(style.base)

    const input = Base('input') as any
    input.addClass(style.input)
    input.el.setAttribute('placeholder', 'Add an item…')
    input.el.setAttribute('type', 'text')

    const enterBtn = Img('/images/add-icon.svg')
    enterBtn.addClass(style.enterBtn)

    base.append(input, enterBtn)

    const el = () => input.el as HTMLInputElement
    const syncEnterBtn = () => enterBtn.toggleClass(style.enterBtnActive, el().value.trim().length > 0)

    const submit = () => {
        const value = el().value.trim()
        if (!value) return
        base.emit('add', { value })
        el().value = ''
        syncEnterBtn()
    }

    enterBtn.el.onclick = submit
    input.el.addEventListener('input', syncEnterBtn)
    input.el.addEventListener('keydown', (e: KeyboardEvent) => {
        if (e.key === 'Enter') submit()
    })

    return Object.assign(base, {
        focus: () => el().focus(),
    })
}
